import Task from '../../helper/task';

export default {
    settings: {
        persist: {
            storageKeyPathMapping: {
                tasks: [ 'stack' ]
            }
        },
        persistDistinct: {
            stack: {
                storage: 'db',
                storageKey: 'tasks',
                mode: 'syncList',
            },
            unique: {
                storage: 'local'
            }
        }
    },

    module: {
        namespaced: true,
        
        state: {
            stack: [],
            unique: {}
        },
        getters: {
            findByName(state) {
                return name => { return state.stack.find(p => p.name == name); }
            }
        },
        mutations: {
            add(state, task) {
                const taskName = task.name();
                const taskData = {
                    id: task.id,
                    type: task.type,
                    name: taskName,
                    data: task.data(),
                    handler: task.handler
                };

                if(taskName && taskName in state.unique) {
                    const existentTypeTaskId = state.stack.findIndex(p => p.id === state.unique[taskName]);

                    if(existentTypeTaskId == -1) {
                        state.stack.push(taskData);
                    } else {
                        state.stack.splice(existentTypeTaskId, 1, taskData);
                    }
                } else {
                    state.stack.push(taskData);
                }
            },
            addUnique(state, task) {
                if(!task.name()) {
                    throw new Error("Cannot add unique task: task name not set");
                }

                state.unique[task.name()] = task.id;
            },
            update(state, task) {
                const taskId = typeof task == 'object' ? task.id : task;
                const taskData = state.stack.find(p => p.id === taskId);

                taskData.type = task.type;
                taskData.data = task.data();
                taskData.handler = task.handler;
            },
            remove(state, task) {
                const taskId = typeof task == 'object' ? task.id : task;
                const taskIndex = state.stack.findIndex(p => p.id == taskId);

                state.stack.splice(taskIndex, 1);
            },
            clear(state) {
                state.stack = [];
            }
        },
        actions: {
            run({ commit, rootState }, task) {
                if(rootState.offline) {
                    // defer task and add it to the stack for later execution if we are offline
                    commit('add', task);

                    // add proxy to task handler object so we can commit handler changes to the store
                    const handlerProxy = new Proxy(task.handler, {
                        set(obj, prop, newVal) {
                            obj[prop] = newVal;
                            commit('update', task);
                            return true;
                        }
                    });
        
                    task.handler = handlerProxy;
                    
                    return task.defer();
                } else {
                    // run task directly if we are online
                    return task.run();
                }
            },
            runUnique({ commit, dispatch }, task) {
                const result = dispatch('run', task);

                commit('addUnique', task);

                return result;
            },
            runStack({ state, commit, dispatch }) {
                state.stack.forEach(taskData => {
                    let task = (new Task(taskData.type, taskData.data)).name('name' in taskData ? taskData.name : null).run();
                    
                    if(taskData.handler.resolved.length) {
                        taskData.handler.resolved.forEach(handler => {
                            task = task.then(handler);
                        })
                    }

                    if(taskData.handler.rejected.length) {
                        taskData.handler.rejected.forEach(handler => {
                            task = task.catch(err => {
                                task.getHandler(handler)(err);
                                throw err;
                            });
                        })
                    }

                    if(taskData.handler.finally.length) {
                        taskData.handler.finally.forEach(handler => {
                            task = task.finally(handler);
                        })
                    }

                    task.finally(() => {
                        commit('remove', taskData.id);
                    });

                    dispatch('alerts/addFromTask', { task: task, to: 'connectivity' }, { root: true });
                });
            }
        }
    }
}